import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { coinsService } from '../../services/coins.service';
import { assessmentService } from '../../services/assessment.service';
@Component({
  selector: 'app-identification-comments',
  templateUrl: './identification-comments.component.html',
  styleUrls: ['./identification-comments.component.scss'],
  standalone: false,
})
export class IdentificationCommentsComponent implements OnInit {

  coinId:string;
  coin;
  identifications;
  assessments;
  
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private coinService: coinsService,
    private assessmentService: assessmentService,
    private dialogRef: MatDialogRef<IdentificationCommentsComponent>
  ){
 
  }

  ngOnInit(): void {
  this.getCoinIdentifications();

  }

  getCoinIdentifications(){
    this.coinService.getCoinIdentificationsById(this.data).subscribe(res => {
      this.coin = res.data;
      this.identifications = this.coin.identifications;
      this.getAllCoinAssessments();
    })
  }

  getAllCoinAssessments(){
    this.assessmentService.getAllCoinAssessments(this.data).subscribe(res => {
      this.assessments = res.data;
    })
  }


  onClose() {
    this.dialogRef.close();
  }
}
